import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import moment from 'moment/moment';

import { _adminUsersGet } from "../services/apiConnections.service";

export const AdminUsers = () => {

    const [token, setToken] = useState(null);
    const [users, setUsers] = useState([]);
    const [error, setError] = useState(null);
    const [searchEmail, setSearchEmail] = useState('');

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalItems, setTotalItems] = useState(0);

    useEffect(() => {
        const storedToken = localStorage.getItem('token');
        setToken(storedToken);
    }, []);

    useEffect(() => {
        if (token) {
            getData();
        }
    }, [token]);

    const getData = async (options = {}) => {
        if (!token) return;

        const params = {
            page: options.page !== undefined ? options.page : page,
            page_size: options.pageSize !== undefined ? options.pageSize : pageSize,
            sort_by: options.sortField !== undefined ? options.sortField : defaultSorted[0].dataField,
            sort_order: options.sortOrder !== undefined ? options.sortOrder : defaultSorted[0].order
        };

        const emailToSearch = options.searchEmail !== undefined ? options.searchEmail : searchEmail;
        if (emailToSearch) {
            params.search = emailToSearch;
        }

        let result = await _adminUsersGet(token, params);
        if (result.error) {
            console.log("--error:", result.error);
        } else {
            setUsers(result.users);
            setTotalItems(result.total_items);
            // State for page and pageSize is updated in handleTableChange or remains for filters/sort
            if (options.page !== undefined) setPage(options.page);
            if (options.pageSize !== undefined) setPageSize(options.pageSize);
            setError(null);
        }
        setError(result.error);
    };

    const handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
        switch (type) {
            case 'pagination':
                setPage(page);
                setPageSize(sizePerPage);
                getData({ page, pageSize: sizePerPage, sortField, sortOrder });
                break;
            case 'sort':
                getData({ sortField, sortOrder });
                break;
            default:
                break;
        }
    };

    const handleSearch = (value) => {
        setSearchEmail(value);
        // getData will use the current page and pageSize from state
        getData({ searchEmail: value });
    };

    const dateColumnFormatter = (cell, row) => {
        return (
            <span>{moment(new Date(cell)).format('yyyy-MM-DD H:mm')}</span>
        );
    };

    const editFormatter = (cell, row) => {
        return (
            <Link className='tableIconBtn' to={`admin-user-edit/${Number(row.id)}`}>
                <FontAwesomeIcon icon={solid('pencil')} />
            </Link>
        )
    };

    const columns = [
        {
            dataField: 'registration_date',
            text: 'Creation Date',
            sort: true,
            formatter: dateColumnFormatter
        },
        {
            dataField: 'email',
            text: 'Email',
            sort: true
        },
        {
            dataField: 'first_name',
            text: 'First Name',
            sort: true
        },
        {
            dataField: 'last_name',
            text: 'Last Name',
            sort: true
        },
        {
            dataField: 'id',
            text: 'Edit',
            classes: 'iconColumn',
            formatter: editFormatter
        },
    ];

    const defaultSorted = [
        {
            dataField: 'email',
            order: 'asc'
        }
    ];

    const pagination = paginationFactory({
        page,
        sizePerPage: pageSize,
        totalSize: totalItems,
        showTotal: true,
        hidePageListOnlyOnePage: true,
        hideSizePerPage: totalItems <= 10
    });

    const noData = () => {
        return <p className='emptyTableMessage'>No matching records found</p>
    };

    return (
        <div className='content wideContent'>
            <div>
                <div className='pageTitle'>
                    <span>Admin Users</span>
                </div>
                {error && <p className='msgBlock errorMsg'>{error}</p>}
                <div className='row'>
                    <div className='col-lg-12'>
                        <div className='myTable'>
                            <div className='tableHeader'>
                                <Link className='mainBtn btn' to={'/add-admin-user'}>Add Admin User</Link>
                                <div className="fewFilters mb-3">
                                    <div className='col-6'>
                                        <label
                                            className='inputLabel'
                                            htmlFor='emailFilter'>
                                            Email
                                        </label>
                                        <input
                                            id='emailFilter'
                                            name='emailFilter'
                                            type='text'
                                            className='searchInput'
                                            placeholder='Search...'
                                            value={searchEmail}
                                            onChange={(event) => handleSearch(event.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <BootstrapTable
                                keyField='id'
                                data={users}
                                columns={columns}
                                wrapperClasses='table-responsive'
                                bordered={false}
                                pagination={pagination}
                                onTableChange={handleTableChange}
                                remote={{ pagination: true, sort: true }}
                                defaultSorted={defaultSorted}
                                noDataIndication={noData} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};